import { render, staticRenderFns } from "./likeFllow.vue?vue&type=template&id=65aa4fcb&scoped=true&"
import script from "./likeFllow.vue?vue&type=script&lang=js&"
export * from "./likeFllow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aa4fcb",
  null
  
)

export default component.exports